import(/* webpackMode: "eager", webpackExports: ["EditShopItemForm"] */ "/app/components/admin/shop-items/edit-shop-item-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShopItemFormDialog"] */ "/app/components/admin/shop-items/shop-item-form-dialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShopItemList"] */ "/app/components/admin/shop-items/shop-item-list.tsx");
